export function clearEmptyFields(obj: $TSFixMe) {
  const currObj = Object.assign({}, obj);
  const keys = Object.keys(currObj);

  keys.forEach((k) => {
    if (!currObj[k]) {
      delete currObj[k];
    }
  });

  return currObj;
}
